import { render, staticRenderFns } from "./DatePickerPage.vue?vue&type=template&id=206987f6&"
import script from "./DatePickerPage.vue?vue&type=script&lang=js&"
export * from "./DatePickerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports